import { updateZoneRequest } from "../../data/zoneApi";
import { validateZonePayload } from "../validator/validateZonePayload";

export async function updateZoneUseCase(payload) {
  const error = validateZonePayload(payload);

  if (error) {
    throw new Error(error);
  }

  return await updateZoneRequest(payload);
}
